<template>
	<section class="appraisal bg-success py-5">
		<div class="container">
			<div class="row">
				<div class="col-md-3 text-center text-md-left">
					<img src="https://hviorder.ca/img/max.svg" class="">
				</div>
				<div class="col-md-7 text-center text-md-left text-white align-self-center">
					<h1 class="text-white">The easiest way to order an appraisal online</h1>
					<p class="text-body">
						Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci autem
						dolore dolorum ducimus eum libero omnis perferendis quibusdam soluta
						temporibus. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem, tempore?
					</p>
					<div class="auth-buttons">
						<button class="btn btn-primary mr-3 shadow-lg">Sign Up</button>
						<button class="btn btn-accent shadow-lg">Login</button>
					</div>
				</div>
			</div>
		</div>
	
	</section>
</template>

<script>
	export default {
		name: 'Appraisal',
		data () {
			return {}
		}
	}
</script>
